import { authenticatedGet, authenticatedPost, authenticatedDelete } from "../../api/authenticatedFetch";

const BASE = "/api/v1/litellm/ingest-tokens";

// listIngestTokens returns this customer's tokens (masked, newest first). Never contains secrets.
export const listIngestTokens = async () => {
  const res = await authenticatedGet(BASE);
  return res?.ingest_tokens ?? [];
};

// createIngestToken mints a token. The response carries the one-time secret under `ingest_token`.
export const createIngestToken = async (label) => {
  const res = await authenticatedPost(BASE, { label });
  return res?.ingest_token ?? res;
};

// revokeIngestToken revokes a token by id. Response is the updated (revoked) token under `ingest_token`.
export const revokeIngestToken = async (id) => {
  const res = await authenticatedDelete(`${BASE}/${id}`);
  return res?.ingest_token ?? res;
};
